import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  Typography,
  useTheme,
} from "@mui/material";

const DetailCardComp = ({
  data,
  content,
  action,
  headerLabel,
  maxHeight = "auto",
  onClick = () => {},
}) => {
  const theme = useTheme();

  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: "8px",
        overflow: "hidden",
        border: "1px solid #e0e0e0",
        backgroundColor: "#ffffff",
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
        mb: 0,
        transition: "transform 0.2s ease",
        "&:hover": {
          transform: "scale(1.02)",
        },
      }}
      onClick={() => onClick(data)}
    >
      {/* Header section */}
      <Box
        sx={{
          backgroundColor: "#f5f5f5",
          px: 2,
          py: 1,
          borderBottom: "1px solid #ddd",
        }}
      >
        <div>
          <Typography
            variant="subtitle2"
            fontWeight="600"
            sx={{
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              width: "100%",
              fontSize: "inherit",
            }}
          >
            {headerLabel}
          </Typography>
        </div>
      </Box>
      <CardContent sx={{ p: 2, pb: "16px !important" }}>{content}</CardContent>
      <CardActions sx={{ padding: "0px !important" }}>{action}</CardActions>
    </Card>
  );
};

export function DetailInputDisplay({ label, value }) {
  return (
    <>
      <Grid item xs={6} sm={6} md={4}>
        <Typography variant="caption" color="primary">
          {label}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            width: "100%",
            fontSize: "inherit", // match surrounding font
          }}
        >
          {" "}
          {value}
        </Typography>
      </Grid>
    </>
  );
}

export function DetailButton({ label, xonClick, icon }) {
  const theme = useTheme();

  return (
    <>
      {/* <Grid item xs={6} sm={6} md={4} > */}
      <Button
        variant="contained"
        size="small"
        onClick={xonClick}
        sx={{
          textTransform: "capitalize",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          maxWidth: 100, // adjust as needed
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "4px 8px",
          fontSize: "10px !important",
          minWidth: 0,
          flexShrink: 1,
        }}
        endIcon={icon}
      >
        {label}
      </Button>

      {/* </Grid> */}
    </>
  );
}

export default DetailCardComp;
